<app-supprots-ai-help-desk
  [mainTitle]="'মেন্টরইআরপি সাপোর্ট সমূহ'"
  [features]="[
    { title: 'রেজাল্ট প্রসেসিং ও মার্কশিট', description: '' },
    { title: 'ডিজিটাল ফি কালেকশন ও গেটওয়ে সাপোর্ট', description: '' },
    { title: 'ছাত্র-শিক্ষক অ্যাটেনড্যান্স', description: '' },
    { title: 'অনলাইন ভর্তি ও রেজিস্ট্রেশন', description: '' },
    { title: 'ডেটা ব্যাকআপ ও মাইগ্রেশন​', description: '' },
    { title: 'সফটওয়্যার ট্রেনিং ও গাইডেন্স​', description: '' },
    { title: 'সিস্টেম আপডেট ও বাগ ফিক্স​​', description: '' },
  ]"
  [rightImage]="'dem0.png'">
</app-supprots-ai-help-desk>
<div class="max-w-7xl mx-auto py-3 px-4 font-sans">
    <div class="my-10 text-center">
    <a routerLink="/support-details" class="bg-gradient-primary text-xl cursor-pointer font-semibold text-white px-6 py-3 rounded-lg hover:bg-blue-700 transition-colors">সাপোর্ট পলিসি দেখুন</a>
</div>
<div class="bg-blue-900 text-white p-6 rounded-lg shadow-lg text-center">
    <h3 class="text-2xl py-3 ">সাপোর্ট সময় সূচী (ছুটির দিন ব্যতিত)</h3>
    <p>রবিবার - বৃহস্পতিবারঃ 9:00 AM – 5:00 PM</p>
</div>

<div class="max-w-4xl mx-auto p-6 mt-6 bg-white rounded-xl shadow-lg border border-gray-100">
  <div class="text-center mb-8">
    <h2 class="text-2xl md:text-3xl font-bold text-[#1e266d] inline-block pb-2 border-b-4 border-yellow-400">
      সাপোর্ট পেতে যোগাযোগ করুন
    </h2>
  </div>

  <div class="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">

    <div class="relative rounded-2xl overflow-hidden shadow-inner bg-blue-50">
      <div class="absolute top-4 left-4 z-10">
        <span class="text-blue-800 font-bold text-xl italic">MentorERP</span>
      </div>
      <img fill ngSrc="head-help.png" alt="Support Team" class="w-full h-auto object-cover">
      <div class="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-blue-900/80 to-transparent p-4">
        <p class="text-white text-lg font-semibold text-center">এখন থেকে সকল সেবা সরাসরি হেড অফিস থেকে</p>
      </div>
    </div>

    <div class="space-y-6">
      <div class="flex items-center gap-4">
        <div class="bg-blue-900 p-3 rounded-full text-white">
          <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"></path></svg>
        </div>
        <div>
          <p class="text-sm text-gray-600 font-medium">অর্ডার করতেঃ</p>
          <p class="text-xl font-bold text-green-600">01688667870</p>
        </div>
      </div>

      <div class="flex items-center gap-4">
        <div class="bg-blue-900 p-3 rounded-full text-white">
          <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 00-3-3.87"></path><path d="M16 3.13a4 4 0 010 7.75"></path></svg>
        </div>
        <div>
          <p class="text-sm text-gray-600 font-medium">সাপোর্ট পেতে, হোয়াটসঅ্যাপঃ</p>
          <p class="text-xl font-bold text-green-600">01962-779366</p>
        </div>
      </div>

      <div class="flex items-center gap-4">
        <div class="bg-blue-900 p-3 rounded-full text-white">
          <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path></svg>
        </div>
        <div>
          <p class="text-sm text-gray-600 font-medium">যেকোনো অভিযোগ সংক্রান্তঃ</p>
          <p class="text-xl font-bold text-green-600">01676761887</p>
        </div>
      </div>

      <div class="flex items-center gap-4">
        <div class="bg-blue-900 p-3 rounded-full text-white">
          <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path></svg>
        </div>
        <div>
          <p class="text-sm text-gray-600 font-medium">ইমেইলঃ</p>
          <p class="text-xl font-bold text-green-600 cursor-pointer">mentorerpbd@gmail.com</p>
        </div>
      </div>
    </div>
  </div>
</div>
</div>